// Backend path for authentication
export const API_AUTH_PATH = {
  ADD_USER: '/users',
  LOGIN: '/login',
  //  To Verify Token Received from email
  VERIFY_ID: '/verify',
  //  To Verify Auth Token received while logging in
  VERIFY_TOKEN: '/token',
  FORGOT_PASSWORD: '/forgot',
  RESET_PASSWORD: '/reset',
  LOGOUT: '/logout',
}

// Server routes for user management
export const API_USER_MGMT = {
  USER: '/users',
  UPDATE_COLS: '/users/cols',
}

export const API_STORE_MGMT = {
  STORE: '/store',
}

export const API_AGGREGATOR_MGMT = {
  AGGREGATOR: '/aggregator',
}

export const API_FTP_CONFIGURATION = {
  FTP_CONFIGURATION: '/ftp-configuration',
  STORE: '/ftp-configuration/store',
}

export const API_CONFIG = {
  CONFIG: '/config',
  RMA: '/config/rma',
}

export const API_MASTER_DATA = {
  MASTER_DATA: '/catalogue',
  MASTER_DATA_EXPORT: '/catalogue/export',
  MASTER_DATA_IMPORT: '/catalogue/import',
}

export const API_INVENTORY = {
  INVENTORY: '/inventory',
  INVENTORY_EXPORT: '/inventory/export',
  INVENTORY_IMPORT: '/inventory/import',
  CALL_BY_INVENTORY: '/inventory/callBy/inventory',
}

// Server Routes for Logs
export const API_LOGS = {
  ERP_LOGS: '/log/erp',
  ERP_LOGS_DOWNLOAD: '/log/erp/download',
  POS_LOGS: '/log/pos',
  POS_LOGS_DOWNLOAD: '/log/pos/download',
  FTP_LOGS: '/log/ftp',
  FTP_LOGS_DOWNLOAD: '/log/ftp/download',
  IMPORTS_LOGS: '/log/imports',
  EXPORT_LOGS: '/log/export',
  ORDERS_LOGS: '/log/orders',
  RECONCILIATION_LOGS: '/log/reconciliation',
  RECONCILIATION_LOGS_DOWNLOAD: '/log/reconciliation/download',
  ORDERS_LOGS_DOWNLOAD: '/log/orders/download',
  IMPORTS_LOGS_DOWNLOAD: '/log/imports/download',
  EXPORT_LOGS_DOWNLOAD: '/log/export/download',
  AGGREGATOR_LOGS: '/log/aggregator',
  AGGREGATOR_LOGS_DOWNLOAD: '/log/aggregator/download',
}

// server file download path
export const API_FILE_DOWNLOAD_PATH = {
  DOWNLOAD_CSV: '/export-file/download-csv',
}

// Server Routes for Smart OOS
export const API_SMART_OOS = {
  UPLOAD: '/smart-oos/upload',
  SMART_OOS: '/smart-oos',
}

// Server Routes for Pricing
export const API_PRICING = {
  PRICING: '/pricing',
  PRICING_IMPORT: '/pricing/import',
  CALL_BY_PRICE: '/pricing/call/price',
  PRICING_EXPORT: '/pricing/export',
}

// Server routes for function and jobs
export const FUNCTION_JOBS = {
  GENERATE_FTP_FILE: '/function-jobs',
}

export const API_CRON = {
  CRON_MASTER: 'cron/master',
  CRON_INVENTORY: 'cron/inventory',
  CRON_PRICING: 'cron/pricing',
  CRON_SYNC_AGG: 'cron/sync-aggregator-pricing',
}

export const API_ORDER = {
  ORDERS: '/order',
  ORDERS_BY_STORE: '/order/store',
  ORDERS_EXPORT: '/order/export',
  ORDERS_SYNC: '/order/sync',
  RECONCILIATION_SYNC: '/order/reconciliation-sync',
}
